import React from 'react'
import { Container, Message } from './style'

const PreProgramming: React.FC = () => {
  return (
    <Container>
      <Message>Pré-programação em desenvolvimento</Message>
    </Container>
  )
}

export default PreProgramming
